import { atomWithStorage } from "jotai/utils";
import {
	type SortKey,
	SortTypes,
} from "web_myplann/Portfolio/Components/SortDrawer";

export type PortfolioSortState = {
	portfolioSortValue: SortKey;
};

const defaultState: PortfolioSortState = {
	portfolioSortValue: SortTypes.default,
};

export const portfolioSortState = atomWithStorage<PortfolioSortState>(
	"MYPLANN_PORTFOLIO_SORT_STATE",
	defaultState,
);
